import { createAction, props } from '@ngrx/store';
import { FloatingFilterChangeCallBackParam } from '@shared/components/ag-grid-floating-filter/ag-grid-floating-filter.model';
import { TrafficStatisticsParams } from '../traffic-statistics.model';

export const setTrafficStatisticsConfig = createAction(
  '[Traffic Statistics] config',
  props<{ trafficStatisticsConfig: TrafficStatisticsParams }>()
);

export const setTrafficStatisticsColumnSearch = createAction(
  '[Traffic Statistics] column search',
  props<{ columnSearch: FloatingFilterChangeCallBackParam }>()
);

export const clearTrafficStatisticsColumnSearch = createAction(
  '[Traffic Statistics] clear column search'
);

export const clearTrafficStatistics = createAction('[Traffic Statistics] clear');
